import _ from "lodash";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";
import { store } from "store/createStore";

// eslint-disable-next-line disable-autofix/import/no-namespace
import * as ENTITY_FLOW_UTILS from "./EntityFlow/utils";
// eslint-disable-next-line disable-autofix/import/no-namespace
import * as LEARNING_COURSE_FLOW_UTILS from "./LearningCourseFlow/utils";

export const PUSHER_EVENTS = {
  FEED_UPDATE: "unitFlowFeedUpdate",
  RESOURCE_UPDATE: "unitFlowResourceUpdate",
};

const getIsLearningCoursesEnabledForUnit = () => {
  return Boolean(
    _.get(
      store?.getState(),
      "planner.unitPlanData.learningCourseId",
      getIsLearningCoursesEnabled()
    )
  );
};

export const getUnitFlowUtils = () =>
  getIsLearningCoursesEnabledForUnit()
    ? LEARNING_COURSE_FLOW_UTILS
    : ENTITY_FLOW_UTILS;
